import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { LogoMark } from "@/components/site/Logo";
import { api, errorText } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const field = "w-full rounded-2xl bg-white/[0.03] border border-white/10 px-4 py-3.5 text-white placeholder:text-slate-500 focus:outline-none focus:border-[#d5d9df]/70";

export default function AdminLogin() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data?.role !== "admin") {
        await api.post("/auth/logout").catch(() => {});
        setUser(false);
        setError("This account doesn't have studio access.");
        setBusy(false);
        return;
      }
      setUser(data);
      nav("/admin");
    } catch (err) {
      setError(errorText(err));
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen grid place-items-center px-5 relative" data-testid="admin-login-page">
      <div className="absolute inset-0 grid-floor opacity-60" />
      <form onSubmit={submit} className="relative glass rounded-[28px] p-8 sm:p-10 max-w-md w-full">
        <LogoMark className="h-10 w-10 mb-6" />
        <h1 className="font-display text-2xl font-bold mb-2">Studio login</h1>
        <p className="text-slate-400 text-sm mb-8">Frame Shift order dashboard</p>
        <div className="space-y-3">
          <input data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className={field} />
          <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className={field} />
        </div>
        {error && <p data-testid="admin-login-error" className="text-red-400 text-sm mt-4">{error}</p>}
        <button data-testid="admin-login-submit" disabled={busy} className="btn-primary w-full justify-center py-4 mt-6">
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Sign in"}
        </button>
      </form>
    </main>
  );
}
